import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  FormTextarea,
} from "@/components/ui";

interface LostReasonDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
  isSubmitting?: boolean;
}

/**
 * Gates a closed_lost drop behind a required reason. Cancel reverts —
 * the caller never mutates the board until onConfirm fires.
 */
export function LostReasonDialog({
  open,
  onCancel,
  onConfirm,
  isSubmitting,
}: LostReasonDialogProps) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} ariaLabel="Mark inquiry as lost">
      <DialogContent size="sm">
        <DialogHeader onClose={onCancel}>Mark as lost</DialogHeader>
        <DialogBody>
          <FormTextarea
            label="Lost reason"
            required
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why did this one fall through?"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={!reason.trim() || isSubmitting}
            onClick={() => onConfirm(reason.trim())}
          >
            {isSubmitting ? "Saving..." : "Mark lost"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
